import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { Component } from 'react';
import { Button } from '../components/button';
import { EmptyScreen } from '../components/empty-screen/index';
export class AddPageForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            name: '',
            pageToken: '',
            queueId: '',
            errors: {},
            formError: null,
            submitting: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.validate = this.validate.bind(this);
        this.hasError = this.hasError.bind(this);
    }
    validate() {
        const errors = {};
        if (!this.state.id) {
            errors.id = 'Please fill out this field';
        }
        if (!this.state.name) {
            errors.name = 'Please fill out this field';
        }
        if (!this.state.pageToken) {
            errors.pageToken = 'Please fill out this field';
        }
        if (!this.state.queueId) {
            errors.queueId = 'Please select a queue';
        }
        this.setState({
            errors,
            formError: null,
        });
        return Object.keys(errors).length === 0;
    }
    hasError(field) {
        return typeof this.state.errors[field] !== 'undefined';
    }
    handleSubmit(event) {
        event.preventDefault();
        if (this.validate()) {
            this.setState({
                submitting: true,
            });
            this.props
                .addPage({
                id: this.state.id,
                name: this.state.name,
                appId: this.props.appId,
                pageToken: this.state.pageToken,
                queueId: this.state.queueId,
            })
                .then(() => {
                this.props.onSuccess();
            })
                .catch((error) => {
                if (error.response.status === 422) {
                    this.setState({
                        errors: {
                            pageToken: 'The provided Page Token is invalid',
                        },
                    });
                }
                else {
                    this.setState({
                        formError: 'Something went wrong, please check the fields',
                    });
                }
            })
                .finally(() => {
                this.setState({
                    submitting: false,
                });
            });
        }
    }
    handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        this.setState({
            [name]: target.value,
        });
        if (this.hasError(name)) {
            setTimeout(() => {
                this.validate();
            });
        }
    }
    render() {
        return (_jsxs("div", { children: [_jsxs("form", Object.assign({ className: classnames('messenger-form', {
                        'messenger-form--submitting': this.state.submitting,
                    }), onSubmit: this.handleSubmit }, { children: [_jsx("h2", Object.assign({ className: "messenger-form__headline" }, { children: "Add page and subscribe to events" })), _jsxs("div", Object.assign({ className: "messenger-form__field" }, { children: [this.hasError('id') && (_jsx("p", Object.assign({ className: "messenger-form__field__error" }, { children: this.state.errors.id }))), _jsx("label", Object.assign({ htmlFor: "messenger-page-id", className: "messenger-form__field__label" }, { children: "ID" })), _jsx("input", { id: "messenger-page-id", type: "text", name: "id", className: classnames('messenger-form__field__input', {
                                        'messenger-form__field__input--error': this.hasError('id'),
                                    }), placeholder: "Type your page id...", value: this.state.id, onChange: this.handleInputChange })] })), _jsxs("div", Object.assign({ className: "messenger-form__field" }, { children: [this.hasError('name') && (_jsx("p", Object.assign({ className: "messenger-form__field__error" }, { children: this.state.errors.name }))), _jsx("label", Object.assign({ htmlFor: "messenger-page-name", className: "messenger-form__field__label" }, { children: "Name" })), _jsx("input", { id: "messenger-page-name", type: "text", name: "name", className: classnames('messenger-form__field__input', {
                                        'messenger-form__field__input--error': this.hasError('name'),
                                    }), placeholder: "Type your page name...", value: this.state.name, onChange: this.handleInputChange })] })), _jsxs("div", Object.assign({ className: "messenger-form__field" }, { children: [this.hasError('pageToken') && (_jsx("p", Object.assign({ className: "messenger-form__field__error" }, { children: this.state.errors.pageToken }))), _jsx("label", Object.assign({ htmlFor: "messenger-page-token", className: "messenger-form__field__label" }, { children: "Page token" })), _jsx("input", { id: "messenger-page-token", type: "text", name: "pageToken", className: classnames('messenger-form__field__input', {
                                        'messenger-form__field__input--error': this.hasError('pageToken'),
                                    }), placeholder: "Type your page token...", value: this.state.pageToken, onChange: this.handleInputChange })] })), _jsxs("div", Object.assign({ className: "messenger-form__field" }, { children: [this.hasError('queueId') && (_jsx("p", Object.assign({ className: "messenger-form__field__error" }, { children: this.state.errors.queueId }))), _jsx("label", Object.assign({ htmlFor: "messenger-page-queue", className: "messenger-form__field__label" }, { children: "Queue" })), _jsxs("select", Object.assign({ id: "queue", className: classnames('messenger-form__field__input', 'messenger-form__field__input--select', {
                                        'messenger-form__field__input--error': this.hasError('queueId'),
                                    }), name: "queueId", value: this.state.queueId, onChange: this.handleInputChange }, { children: [_jsx("option", Object.assign({ value: "", hidden: true }, { children: "Please select a queue" })), this.props.queues.map((queue, i) => (_jsx("option", Object.assign({ value: queue.id }, { children: queue.name }), i)))] }))] })), _jsxs("div", Object.assign({ className: "messenger-form__actions" }, { children: [!!this.state.formError && (_jsx("p", Object.assign({ className: "messenger-form__error" }, { children: this.state.formError }))), _jsx(Button, Object.assign({ disabled: this.state.submitting, className: "messenger-form__submit" }, { children: "Continue" }))] }))] })), _jsx(EmptyScreen, { headline: "Facebook Messenger setup steps", ingredients: {
                        '1. Setup Facebook Messenger': 'https://support.dixa.help/en/articles/133',
                        '2. Setup Messenger Webhooks': 'https://support.dixa.help/en/articles/134-setup-messenger-webhooks',
                        '3. Add Facebook page': 'https://support.dixa.help/en/articles/135-add-facebook-page',
                        '4. Submit for review and publish': 'https://support.dixa.help/en/articles/136-submission-for-review-and-make-the-app-public',
                    } })] }));
    }
}
